import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { PlusCircle, Trash } from "react-bootstrap-icons";
import { Button, Col, Row, Table } from "react-bootstrap";
import Loader from 'react-loader-spinner';
import { loadProductAccessories, setDialog } from "../../store/api/GetAllProduct";
import { deleteServiceDetail, loadServiceAccessories, addServiceDetails } from "../../store/api/TaskDetailsApi";
import ModalSelectProductAccessory from "./ModalSelectProductAccessory";
import BihamtaMultiSelect from "../../../Components/BihamtaMultiSelect";
import { clearAll } from "../../../Components/BihamtaMultiSelect";
const ServiceProductAccessories = (props) => {
    const { serviceID, serviceType, productID, productTypeID, accessoryList, pgType } = props;
    const dispatch = useDispatch();
    const [modalPA, setModalPA] = useState({ show: false });
    const [accList, setAccList] = useState([]);
    const selectedAccList = useRef([]);
    const saveDetail = () => {
        if (!(selectedAccList.current?.length > 0)) {
            return;
        }
        const data = [];
        selectedAccList.current.forEach(itm => {
            data.push({
                AccessoryID: itm,
                ServiceID: serviceID,
                ServiceType: serviceType,
                DetailType: 0
            })
        });
        const onAdd = () => {
            selectedAccList.current = [];
            clearAll();
            dispatch(loadServiceAccessories(serviceID, serviceType));
        }
        addServiceDetails(data, onAdd);
    }
    function onServiceAccChanged(item) {
        if (!selectedAccList.current) {
            selectedAccList.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!selectedAccList.current.includes(splited) && !accessoryList.some(a => splited.includes(a.AccessoryID?.toString()))) {

                selectedAccList.current.push(...splited);
            }
        }
        else {
            selectedAccList.current = selectedAccList.current.filter(a => !splited.includes(a));
        }
    }
    useEffect(() => {
        loadProductAccessories({
            productID: pgType === 1 ? productID : 0,
            productType: productTypeID
        }, setAccList);
    }, [])
    return (
        <Fragment>
            <ModalSelectProductAccessory popData={modalPA} setPopData={setModalPA} />
            <Row>
                <Col md={6} className="form-group">
                    <div style={{ width: "80%", display: "inline-block" }}>
                        <label>نام لوازم</label>
                        <BihamtaMultiSelect dataSource={accList?.Data} valueItem="ID" displayItem="AccessoryName" onItemCheckChanged={onServiceAccChanged} defaultCheckedList={selectedAccList.current}/>
                    </div>
                    <Button title="افزودن به لیست" variant="info" className="group-Btn-smalll" onClick={saveDetail}><PlusCircle size={23} /></Button>
                </Col>
            </Row>
            <Table responsive className="mt-2">
                <thead>
                    <tr>
                        <th style={{ width: "30px" }}></th>
                        <th>نام لوازم</th>
                        <th style={{ width: "30px" }}> </th>
                    </tr>
                </thead>
                <tbody>
                    {accessoryList === "PENDING" && <tr><td colSpan={3} style={{ textAlign: "center", width: "100%" }}> <Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></td></tr>}
                    {accessoryList && Array.isArray(accessoryList) &&
                        accessoryList.map((item, i) =>
                            <tr key={i} className="resultTableRow">
                                <td style={{ width: "30px" }}>{i + 1}</td>
                                <td>{item.AccessoryName}</td>
                                <td style={{ width: "30px" }}><button className="btn btn-block" style={{padding:0}} type="button" onClick={() => {
                                    dispatch(setDialog({
                                        status: 'show',
                                        arrayBtn: ['yes', 'no'],
                                        dialogTitle: 'حذف لوازم همراه',
                                        dialogText: 'آیا از حذف مطمئن هستید؟',
                                        okOperation: deleteServiceDetail(item.ID, () => { dispatch(loadServiceAccessories(serviceID, serviceType)) })
                                    }))
                                }} ><Trash color="red" size={18} /></button></td>
                            </tr>)
                    }
                </tbody>
            </Table>
        </Fragment>
    )
}
export default ServiceProductAccessories;